import { CheckOutlined } from "@ant-design/icons";
import { Button } from "antd/es";
import { Table } from "antd/es";
import { useState } from "react";
import { ImageSelector } from "../ImageSelector";


export const ImageLosses = (props) => {
    const { losses, relative, files, imageNames, captions } = props;

    const [selectedFile, setSelectedFile] = useState(null);
    const [copied, setCopied] = useState(false);
    // const [exportCaptions, setExportCaptions] = useState(false);
    async function exportCaptions() {
        try {
            const all = captions.split("\n").map(c => c.trim()).filter(c => c);
            const result = [];

            for (const e of all) {
                const [f, cap] = e.split("=");
                const loss = (relative[f] ?? 1.0).toFixed(8);
                result.push(`${f}=${cap}=loss:${loss}`);
            }

            result.push("");

            const text = result.join('\n');
            await navigator.clipboard.writeText(text);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (error) {
            console.error(error.message);
        }
    }


    return (<div>
        <div style={{ display: 'flex' }}>
            <div style={{ flex: 1 }}>
                <ImageSelector bind={[selectedFile, setSelectedFile]} imageNames={imageNames} />
            </div>

            <div style={{ flex: 1 }}>
                <Button block type={copied ? "primary" : "default"} color="" onClick={exportCaptions} icon={copied ? <CheckOutlined /> : undefined}>{copied ? "" : "Export captions"}</Button>
                {/* <Checkbox checked={exportCaptions} onChange={ev => setExportCaptions(ev.target.checked)}>Export sorted captions</Checkbox> */}
            </div>
        </div>

        {selectedFile && <>
            <table className="image-losses" style={{ marginTop: 8 }}>
                <thead>
                    <tr>
                        <th>Step</th>
                        <th>Timestep</th>
                        <th>Loss</th>
                        <th>Caption</th>
                    </tr>
                </thead>
                <tbody>
                    {losses[selectedFile].slice(0, 100).map(f => <tr key={f}>
                        <td className="">{f.step}</td>
                        <td className="">{f.timestep}</td>
                        <td className="monospaced loss-value">{f.loss.toFixed(5)}</td>
                        <td className="">{f.caption}</td>
                    </tr>)}
                </tbody>
            </table>
        </>}

        {/* {exportCaptions && <div>
            <pre>{
                files.join('\n')
            }</pre>
        </div>} */}

        <Table
            className="image-losses"
            style={{ marginTop: 8 }}
            rowKey={"f"}
            size="small"
            dataSource={files.map(f => ({ f }))}
            columns={[
                { title: "Rel. avg. loss", render: (f) => relative[f.f].toFixed(5) },
                { title: "Image", render: (f) => <a href="#" onClick={() => setSelectedFile(f.f)}>{f.f.split('/').at(-1)}</a> },
                { title: "Samples", render: v => losses[v.f].length },
            ]}
            pagination={{ position: ["bottomCenter"], responsive: true, size: "small", defaultPageSize: 50 }} />

    </div>);
};
